module.exports = __webpack_public_path__ + "media/application/images/icons/link-be40ce74e0b512573933ed755907ab24.svg";